import { useRouter } from 'next/router'
import { FC } from 'react'

import { trackEvent } from '../../../../../../lib/analytics'
import { useCollectionPersistentProductHref } from '../../../../../../lib/routing'

import { StyleLink } from './styles'

type Props = {
  title: string
  handle: string
}

export const StyleLinkItem: FC<Props> = ({ title, handle }) => {
  const router = useRouter()
  const {
    query: { color, size, fit, plain },
  } = router

  const href = useCollectionPersistentProductHref(handle, {
    color,
    size,
    fit,
    plain,
  })

  return (
    <StyleLink
      key={handle}
      href={href}
      scroll={false}
      replace
      {...trackEvent({
        category: 'product',
        action: 'click',
        label: 'style links',
        value: handle,
      })}
    >
      {title}
    </StyleLink>
  )
}
